import React from "react";
import PropTypes from "prop-types";
import AppRoutes from "routes/app";
import { MainContainer, MainContent } from "./LayoutStyles";
import { connect } from "react-redux";

const Main = ({ isLoadingUser }) => {
  return (
    <MainContent>
      <MainContainer>{!isLoadingUser && <AppRoutes />}</MainContainer>
    </MainContent>
  );
};

Main.propTypes = {
  isLoadingUser: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    isLoadingUser: state.oidc.isLoadingUser
  };
}

export default connect(mapStateToProps)(Main);
